import { Navigate } from 'react-router-dom';

/** @deprecated Use /hr/master-data?tab=leave */
export function HrLeavePoliciesPage() {
  return <Navigate to="/hr/master-data?tab=leave" replace />;
}
